import { Injectable } from '@angular/core';
import { SaasTenantDto } from '@volo/abp.ng.saas/proxy';

@Injectable({
  providedIn: 'root',
})
export class TenantCloneStateService {
  private cloneData: SaasTenantDto | null = null;

  setCloneData(tenant: SaasTenantDto): void {
    this.cloneData = tenant;
  }

  getCloneData(): SaasTenantDto | null {
    return this.cloneData;
  }

  clearCloneData(): void {
    this.cloneData = null;
  }
}
